<template>
  <div class="v2-tag" @click="sendTrack">
    {{ tag[`name_${locale}`] }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { amplitudeTrack } from "@/utils/amplitude";
import { PropType } from "vue";
import { Tag } from "@/interfaces/Tags/Tag.ts";

defineOptions({
  name: "app-tag",
});

const props = defineProps({
  tag: {
    type: Object as PropType<Tag>,
    required: true,
  },
});

const { locale } = useI18n();

const sendTrack = () => {
  amplitudeTrack("Tag clicked", { tag: props.tag.name_en });
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
